"use client"
import { WorkspaceDisclosure } from "@/components/workspace/workspace-disclosure"

import { usePathname } from "next/navigation"
import type { AiEvidence } from "@/modules/ai/evidence-contracts"
import { allowedLink } from "./ai-links"

export function AiEvidenceSources({ sources }: { sources?: AiEvidence[] }) {
  const pathname = usePathname()
  if (!sources?.length) return null
  return <WorkspaceDisclosure className="communication-ai-sources" title={`Sources checked (${sources.length})`}>
    <p>These sources were checked for this reply. Record details and availability can change; a reply does not confirm a booking or price.</p>
    <ul>{sources.map(source => {
      const raw = source.kind === "record" && source.href?.startsWith("/") && pathname.startsWith("/crm/") ? "/crm" + source.href : source.href
      const href = allowedLink(raw ?? undefined)
      return <li key={`${source.kind}:${source.id}`}>
        {href ? <a href={href} target="_blank" rel="noopener noreferrer">{source.title}</a> : <span>{source.title}</span>}
        <small>{source.kind === "record" ? "Record" : "Published knowledge"} · revision {source.revision} · checked {new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/New_York" }).format(new Date(source.checkedAt))} ET</small>
      </li>
    })}</ul>
  </WorkspaceDisclosure>
}
